import { useState } from "react";

// Invite an additional administrator to an existing company. The name is
// required too: the invitation email addresses them by it.
function AddAdminModal({ company, onAddClicked, onCancelClicked }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});

  const submit = () => {
    const trimmedName = name.trim();
    const trimmedEmail = email.trim().toLowerCase();

    const next = {};
    if (!trimmedName) next.name = "Full name is required";
    if (!trimmedEmail) next.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail))
      next.email = "Enter a valid email address";

    setErrors(next);
    if (Object.keys(next).length > 0) return;

    onAddClicked({ identifier: company.identifier, name: trimmedName, email: trimmedEmail });
  };

  const clearError = (field) => setErrors((prev) => ({ ...prev, [field]: undefined }));

  const inputBox = (hasError) =>
    `w-full h-[30px] border-solid border-[1px] rounded-[5px] flex items-center px-[15px] ${
      hasError ? "border-red-500" : ""
    }`;

  return (
    <div
      onClick={onCancelClicked}
      className="fixed w-screen h-screen left-0 top-0 bg-black bg-opacity-30 flex items-center justify-center z-30"
    >
      <div onClick={(e) => e.stopPropagation()} className="w-[448px] bg-white rounded-[6px] p-[18px] flex flex-col">
        <p className="text-[16px] font-OpenSansSemiBold text-titleColor mb-1">ADD ADMINISTRATOR</p>
        <p className="text-[12px] leading-[18px] font-OpenSansRegular text-subTitleColor mb-5">
          Invite an administrator to <b>{company?.name}</b>
        </p>

        <div className="flex flex-col gap-4">
          <div className="w-full">
            <p className="text-[12px] leading-[18px] font-OpenSansSemiBold text-titleColor mb-2">
              Administrator Full Name
            </p>
            <div className={inputBox(errors.name)}>
              <input
                value={name}
                type="text"
                onChange={(e) => {
                  setName(e.target.value);
                  clearError("name");
                }}
                className="w-full text-inputEmailTitle text-[12px] font-OpenSansRegular"
                placeholder="Enter administrator full name"
              />
            </div>
            {errors.name && <p className="text-[11px] font-OpenSansRegular text-red-500 mt-1">{errors.name}</p>}
          </div>

          <div className="w-full">
            <p className="text-[12px] leading-[18px] font-OpenSansSemiBold text-titleColor mb-2">Administrator Email</p>
            <div className={inputBox(errors.email)}>
              <input
                value={email}
                type="email"
                onChange={(e) => {
                  setEmail(e.target.value);
                  clearError("email");
                }}
                className="w-full text-inputEmailTitle text-[12px] font-OpenSansRegular"
                placeholder="admin@company.com"
              />
            </div>
            {errors.email && <p className="text-[11px] font-OpenSansRegular text-red-500 mt-1">{errors.email}</p>}
          </div>

          <div className="w-full mt-2">
            <div className="flex items-center justify-between gap-4">
              <div
                onClick={onCancelClicked}
                className="w-[50%] h-[30px] text-[12px] font-OpenSansSemiBold rounded-[6px] border-[1px] border-subTitleColor flex items-center justify-center text-subTitleColor cursor-pointer"
              >
                CANCEL
              </div>
              <div
                onClick={submit}
                className="w-[50%] h-[30px] text-[12px] font-OpenSansSemiBold rounded-[6px] flex items-center justify-center bg-blueColor text-white cursor-pointer"
              >
                INVITE
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddAdminModal;
